<template>
  <div>
    <div class="px-8">
      <div class="font-bold text-deep-dark text-base mb-2">
        {{ $t('frontend_groovevideo_select_yt_account') }}
      </div>
      <div class="youtube-secondary-text text-sm">
        {{ $t('frontend_groovevideo_select_yt_account_desc') }}
      </div>
    </div>
    <div
      class="overflow-auto px-8 mt-6"
      style="max-height: calc(100vh - 400px); min-height: 130px"
    >
      <div
        v-for="(channel, index) in youtubeChannels"
        :key="index"
        class="w-full flex boxStyle"
      >
        <gd-custom-radio
          class="p-4"
          v-model="localModel.youtubeApiId"
          :option="channel"
        ></gd-custom-radio>
      </div>
      <div
        class="
          flex flex-col
          items-left
          mr-4
          mb-4
          rounded
          border
          p-4
          border-grey-200
        "
        @click="addAccount"
      >
        <label class="flex cursor-pointer cursor-pointer">
          <gd-button
            class="
              add-account-btn
              border-2 border-grey-500
              text-xl text-grey-500
            "
          >
            +
          </gd-button>
          <div class="ml-6 flex flex-col w-full">
            <label class="text-pink font-semibold">
              {{ $t('frontend_groovevideo_select_yt_account_add_new_account') }}
            </label>
          </div>
        </label>
      </div>
    </div>
  </div>
</template>

<style scoped>
.add-account-btn {
  width: 27px !important;
  height: 24px !important;
  border-radius: 50% !important;
}
.youtube-secondary-text {
  color: #989ab2;
}
</style>

<script>
import axios from 'axios';
import Swal from 'sweetalert2';
import { required, integer } from 'vuelidate/lib/validators';

export default {
  props: {
    settings: {
      required: true,
    },
    model: {
      required: true,
    },
  },
  data() {
    return {
      localModel: this.model,
      youtubeAccounts: this.settings,
    };
  },
  validations: {
    localModel: {
      youtubeApiId: {
        required,
        integer,
      },
    },
  },
  computed: {
    youtubeChannels() {
      return this.youtubeAccounts.map((el) => {
        return {
          id: el.id,
          title: el.channel_name,
          is_disabled: !el.access_token,
          is_logged_out: !el.access_token,
        };
      });
    },
  },
  mounted() {
    // setup youtube client
    this.$nextTick(() => {
      setTimeout(() => {
        this.google = window.google;
        this.setupYoutubeClient();
      }, 1000);
    });
  },

  methods: {
    setupYoutubeClient() {
      this.client = this.google.accounts.oauth2.initCodeClient({
        client_id: this.$store.getters.youtubeApiClientId,
        scope: 'https://www.googleapis.com/auth/youtube.force-ssl',
        ux_mode: 'popup',
        callback: async (response) => {
          axios.post('youtube-auth', response).then((resp) => {
            if (
              typeof resp.data !== 'undefined' &&
              typeof resp.status !== 'undefined' &&
              resp.status !== 202
            ) {
              const settingIds = this.youtubeAccounts.map((el) => el.id);
              if (!settingIds.includes(resp.data.data.id)) {
                this.youtubeAccounts.push(resp.data.data);
              } else {
                Swal.fire(
                  this.$t('frontend_groovevideo_warning_title'),
                  this.$t(
                    'frontend_groovevideo_select_yt_account_account_exists'
                  ),
                  'warning'
                );
              }
            } else {
              Swal.fire(this.$t('frontend_error'), resp.data.message, 'warning');
            }
          });
        },
      });
    },

    addAccount() {
      this.client.requestCode();
    },

    validate() {
      this.$v.$touch();
      return !this.$v.$invalid;
    },
  },
};
</script>